import React from 'react';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { BellOff } from 'lucide-mui';
import { useTranslation } from 'react-i18next';

const NotificationsEmptyState: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        minWidth: 300,
      }}
    >
      <BellOff
        sx={{
          width: 32,
          height: 32,
          color: theme.palette.text.secondary,
          mb: 2,
        }}
      />
      <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
        {t('drawer.notifications.empty.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center">
        {t('drawer.notifications.empty.message')}
      </Typography>
    </Box>
  );
};

export default NotificationsEmptyState;
